export interface ITypeAheadResult {
    id: number;
    kod?: string;
    group?: string;
    namn: string;
    kortNamn?: string;
    tooltip?: string;
    aktiv: boolean;
    beskrivning?: string;
    grupp?: string;
}

export class TypeAheadResult implements ITypeAheadResult {
    id: number;
    kod?: string;
    group?: string;
    namn: string;
    kortNamn?: string;
    tooltip?: string;
    aktiv: boolean;
    beskrivning?: string;
    grupp?: string;

    constructor(namn: string, aktiv?: boolean, id?: number, group?: string, kod?: string) {
        this.namn = namn;
        if (aktiv !== undefined && aktiv !== null) {
            this.aktiv = aktiv;
        }
        if (id !== undefined && id !== null) {
            this.id = id;
        }
        if (group !== undefined && group !== null) {
            this.group = group;
        }
        if (kod !== undefined && kod !== null) {
            this.kod = kod;
        }
    }
}
